import { getEditorTrackingFieldNames } from "./schemas/getEditorTrackingFields";

export function getFormInvalid(feature, schema) {
  var isInvalid = false;
  var formErrorMessage = null;
  schema.forEach((row) => {
    if (getEditorTrackingFieldNames().includes(row.name) === false) {
      if (
        (feature[row.name] === null && !row.nullable) ||
        (feature[row.name] === "" && !row.nullable) ||
        (feature[row.name] === undefined && !row.nullable)
      ) {
        feature[row.name] = "";
        isInvalid = true;
        row.helperText = `${row.name} is required`;
        row.error = true;
        formErrorMessage =
          "Missing required field: " +
          row.name
            .replace(/_/g, " ")
            .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
      }
    }
  });

  return { feature, isInvalid, formErrorMessage, schema };
}
